module.exports = __webpack_public_path__ + "static/Lora-MediumItalic-f281d9bb9a974ed59f13104278dd1868.ttf";